const DRUGS_LIST_REQUEST = 'DRUGS_LIST_REQUEST';
const DRUGS_LIST_SUCCESS = 'DRUGS_LIST_SUCCESS';
const DRUGS_LIST_FAILURE = 'DRUGS_LIST_FAILURE';

const DRUGS_ADD_REQUEST = 'DRUGS_ADD_REQUEST';
const DRUGS_ADD_SUCCESS = 'DRUGS_ADD_SUCCESS';
const DRUGS_ADD_FAILURE = 'DRUGS_ADD_FAILURE';

// Product type dropdown api
const PRODUCT_TYPE_DROPDOWN_REQUEST = 'PRODUCT_TYPE_DROPDOWN_REQUEST';
const PRODUCT_TYPE_DROPDOWN_SUCCESS = 'PRODUCT_TYPE_DROPDOWN_SUCCESS';
const PRODUCT_TYPE_DROPDOWN_FAILURE = 'PRODUCT_TYPE_DROPDOWN_FAILURE';

// Class dropdown api
const CLASS_DROPDOWN_REQUEST = 'CLASS_DROPDOWN_REQUEST';
const CLASS_DROPDOWN_SUCCESS = 'CLASS_DROPDOWN_SUCCESS';
const CLASS_DROPDOWN_FAILURE = 'CLASS_DROPDOWN_FAILURE';

// recipe type dropdown api
const RECIPE_TYPE_DROPDOWN_REQUEST = 'RECIPE_TYPE_DROPDOWN_REQUEST';
const RECIPE_TYPE_DROPDOWN_SUCCESS = 'RECIPE_TYPE_DROPDOWN_SUCCESS';
const RECIPE_TYPE_DROPDOWN_FAILURE = 'RECIPE_TYPE_DROPDOWN_FAILURE';

// Region DD dropdown api
const REGION_DD_DROPDOWN_REQUEST = 'REGION_DD_DROPDOWN_REQUEST';
const REGION_DD_DROPDOWN_SUCCESS = 'REGION_DD_DROPDOWN_SUCCESS';
const REGION_DD_DROPDOWN_FAILURE = 'REGION_DD_DROPDOWN_FAILURE';

// Region DPC dropdown api
const REGION_DPC_DROPDOWN_REQUEST = 'REGION_DPC_DROPDOWN_REQUEST';
const REGION_DPC_DROPDOWN_SUCCESS = 'REGION_DPC_DROPDOWN_SUCCESS';
const REGION_DPC_DROPDOWN_FAILURE = 'REGION_DPC_DROPDOWN_FAILURE';

// Pharameutical forms dropdown api
const PHARMACEUTICAL_FORMS_DROPDOWN_REQUEST = 'PHARMACEUTICAL_FORMS_DROPDOWN_REQUEST';
const PHARMACEUTICAL_FORMS_DROPDOWN_SUCCESS = 'PHARMACEUTICAL_FORMS_DROPDOWN_SUCCESS';
const PHARMACEUTICAL_FORMS_DROPDOWN_FAILURE = 'PHARMACEUTICAL_FORMS_DROPDOWN_FAILURE';

// Temperature dropdown api
const TEMPERATURE_DROPDOWN_REQUEST = 'TEMPERATURE_DROPDOWN_REQUEST';
const TEMPERATURE_DROPDOWN_SUCCESS = 'TEMPERATURE_DROPDOWN_SUCCESS';
const TEMPERATURE_DROPDOWN_FAILURE = 'TEMPERATURE_DROPDOWN_FAILURE';

export {
    DRUGS_ADD_REQUEST,
    DRUGS_ADD_SUCCESS,
    DRUGS_ADD_FAILURE,
    DRUGS_LIST_REQUEST,
    DRUGS_LIST_SUCCESS,
    DRUGS_LIST_FAILURE,
    PRODUCT_TYPE_DROPDOWN_REQUEST,
    PRODUCT_TYPE_DROPDOWN_SUCCESS,
    PRODUCT_TYPE_DROPDOWN_FAILURE,
    CLASS_DROPDOWN_REQUEST,
    CLASS_DROPDOWN_SUCCESS,
    CLASS_DROPDOWN_FAILURE,
    RECIPE_TYPE_DROPDOWN_REQUEST,
    RECIPE_TYPE_DROPDOWN_SUCCESS,
    RECIPE_TYPE_DROPDOWN_FAILURE,
    REGION_DD_DROPDOWN_REQUEST,
    REGION_DD_DROPDOWN_SUCCESS,
    REGION_DD_DROPDOWN_FAILURE,
    REGION_DPC_DROPDOWN_REQUEST,
    REGION_DPC_DROPDOWN_SUCCESS,
    REGION_DPC_DROPDOWN_FAILURE,
    PHARMACEUTICAL_FORMS_DROPDOWN_REQUEST,
    PHARMACEUTICAL_FORMS_DROPDOWN_SUCCESS,
    PHARMACEUTICAL_FORMS_DROPDOWN_FAILURE,
    TEMPERATURE_DROPDOWN_REQUEST,
    TEMPERATURE_DROPDOWN_SUCCESS,
    TEMPERATURE_DROPDOWN_FAILURE,
}